// extracted by mini-css-extract-plugin
module.exports = {"pinnedFooter":"pinnedcontainer_pinnedFooter__kpvDr","fadein":"pinnedcontainer_fadein__eyfNb","loading":"pinnedcontainer_loading__CjcYl"};